import type { RemoteDiagnoseEvent } from '@/types/remote-diagnose'

const STORE = 'current_store'

export const setStore = async (store: RemoteDiagnoseEvent) => {
  localStorage.setItem(STORE, JSON.stringify(store))
}

export const getStore = () => {
  const store = localStorage.getItem(STORE)
  if (store) {
    return JSON.parse(store)
  }
}

export const removeStore = () => {
  localStorage.removeItem(STORE)
}

export const formatPlate = (plate: string) => {
  return plate.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
}

export const validateQuestionLength = (question: string) => {
  if (!question) return false
  const minWords = 10
  const words = question.trim().split(/\s+/)
  return words.length < minWords
}

export const validateMileage = (mileage: string) => {
  return /^\d+$/.test(mileage) ? Number(mileage) < 1000 : true
}
